import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-validate-logout',
    templateUrl: './validate-logout.component.html',
    styleUrls: ['./validate-logout.component.scss']
})
export class ValidateLogoutComponent {

  constructor(private readonly router:Router){
  setTimeout(() => {
    this.router.navigate(['/'],{replaceUrl:true});
  }, 100);
  }
}
